import { MediaIconElement } from '../base.js';
import { icons } from './icons.js';

if (typeof customElements !== 'undefined' && typeof HTMLElement !== 'undefined') {
  const mediaIconElement = customElements.get('media-icon') || MediaIconElement;

  mediaIconElement.register?.('default', icons);

  if (!customElements.get('media-icon')) {
    customElements.define('media-icon', MediaIconElement);
  }
}
